export default[
    {//首页
        path: '/',
        redirect:"/recently",
        component: function (resolve) {
            require(['./Layout.vue'], resolve);
        },
        children:[
            {
                path: '/recently',
                name:'recently',
                component: function (resolve) {
                    require(['./Recently.vue'], resolve);
                }
            },
            {
                path: '/stardoc',
                component: function (resolve) {
                    require(['./Stardoc.vue'], resolve);
                }
            },
            {
                path: '/recycle',
                component: function (resolve) {
                    require(['./Recycle.vue'], resolve);
                }
            },
            {
                path: '/weekly',
                component: function (resolve) {
                    require(['./Weekly.vue'], resolve);
                }
            },
            {
                path: '/essaywriting',
                component: function (resolve) {
                    require(['./Essaywriting.vue'], resolve);
                }
            },
            {
                path: '/longwriting',
                component: function (resolve) {
                    require(['./Longwriting.vue'], resolve);
                }
            },
            {
                path: '/membership',
                component: function (resolve) {
                    require(['./Membership.vue'], resolve);
                }
            },
        ]
    }
]